module.exports = function getResource(label, vars = []) {
    const resources = {
        uncheckJoinErrorMessage: `You must accept Beauty Insider Terms and Conditions in order to collect ${vars[0]} points from today's purchases.`,
        popoverContent: `Join Beauty Insider to save ${vars[0]} points from your purchase. Redeem for one-of-a-kind experiences, personalized services, and coveted sample rewards.`,
        linkActionText: 'See current rewards',
        dontForgetText: `Don’t forget to save your ${vars[0]} points!`,
        testDontForgetText: `Want to Save Your ${vars[0]} Points?`,
        testDontLosePoints: `Don’t lose your ${vars[0]} points`,
        testBankThemText: 'Bank them — and enjoy great benefits — by joining Beauty Insider, our FREE loyalty program.',
        testSavePointsFreeShip: 'Save them to enjoy great benefits by joining Beauty Insider, our free loyalty program. You’ll also get *FREE standard shipping!*',
        testNewBiPropFree: 'Free',
        testNewBiPropFreeCaps: 'FREE',
        testNewBiPropBDayGift: 'Birthday Gift',
        testNewBiPropFreeGift: 'Free Birthday Gift',
        testNewBiPropFreeCapsGift: 'FREE Birthday Gift',
        testNewBiPropPoints: 'Seasonal Savings Events',
        testNewBiPropRedeem: 'Sample Rewards',
        testNewBiPropShipping: 'FREE Shipping',
        testJoinNowButton: 'Join Now',
        testLegalClickingText: 'By clicking ’Join Now’ you acknowledge that you are a U.S. or Canada resident and agree to',
        testLegalPrivacyPolicyLink: 'Sephora’s Privacy Policy',
        testLegalTermsOfUseLink: 'Terms of Use',
        testLegalBiTermsLink: 'Beauty Insider Terms',
        testLegalAutomaticallyText: ', and to automatically receive Beauty Insider offers and notifications via email.',
        testEnterPasswordToCreateText: `Create a password for ${vars[0]}`,
        enterPasswordToSaveText: 'Enter your Sephora password',
        enterPasswordToSaveDetailsText: `for ${vars[0]} to save your ${vars[1]} points from this purchase.`,
        enterPasswordToCreateText: 'Enter a password to create your account.',
        passwordInputLabel: `Password (${vars[0]} to ${vars[1]} characters)*`,
        forgotText: 'Forgot?',
        savePointsButton: 'Save Points',
        createAccountButton: 'Create Account',
        thankYouText: 'Thank you for signing in!',
        browseBazaarText: 'This order will now appear in your order history. Browse the Rewards Bazaar now!',
        viewBazaarText: 'View Rewards Bazaar'
    };

    return resources[label];
};
